var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center h-full"},[_c('div',{staticClass:"color-chip",style:({ background: _vm.colorHex })})])
}
var staticRenderFns = []

export { render, staticRenderFns }